
const dependantsOptions = [
    { id: 'si_dependientes', label: 'Si', value: 'si' }, 
    { id: 'no_dependientes', label: 'No', value: 'no' }]

export default dependantsOptions